import { PcApiResponse } from '@/api/pc-api/types';
import { BizType } from '@/constants/bizType';
import { SettleInvoiceStatusType, SettleUnitType } from '@/constants/settle';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

export type TraderInfo = {
  address: string;
  businessNumber: string;
  companyName: string;
  representativeName: string;
};

export type History = {
  bizType: keyof typeof BizType;
  chargeEvent: string;
  chargeFinishedAt: string;
  chargeStartedAt: string;
  count: number;
  productCode: string;
  productName: string;
  unitPrice: number;
  usedPrice: number;
  usageAmount?: number;
};

export type SettleInvoiceDetailInfo = {
  id: string;
  unitType: keyof typeof SettleUnitType;
  settleInvoiceStatus: keyof typeof SettleInvoiceStatusType;
  bankAccount: string;
  bankName: string;
  bankRecipient: string;
  includeVat: boolean;
  collectDate: string;
  issueDate: string;
  itemTitle: string;
  supplyPrice: number;
  totalPrice: number;
  vat: number;
  settleId?: string;
  recipient: TraderInfo;
  supplier: TraderInfo;
  calcResult: {
    adjustPrice: number;
    adjustedSupplyPrice: number;
    subTotal: number;
    totalPrice: number;
    vat: number;
  };
  histories: History[];
  exceedChangeableDate: boolean;
  adjustmentInfo?: {
    reason: string;
    adjustEvidenceDocs: { fileName: string; fileUrl: string }[];
  };
};

type GetSettleInvoiceDetailParams = {
  settleInvoiceId: string;
};

export const getSettleInvoiceDetail = ({ settleInvoiceId }: GetSettleInvoiceDetailParams) => {
  return api<PcApiResponse<SettleInvoiceDetailInfo>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/settle-invoice/details/${settleInvoiceId}`
  );
};
